import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import StickyBox from 'react-sticky-box';
// import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
//Styling
import styled from "styled-components";

import toTop from '../../../features/toTop';

//Import Action
import { filterCategories, filterManufacturer, filterDelivery, cleanFilter, cleanCategory } from '../../../../action'

//Import Utils
import { stickyContentHandle, setStickyValues } from '../../../../utils';

function ShopSidebar(props) {
  const [showClean, setShowClean] = useState(false);
  const { filterCategories, filterManufacturer, filterDelivery, link = "", filter, categories, manufacturers, cleanFilter, cleanCategory, productsCatalog, products } = props;

  useEffect(() => {
    setStickyValues(120);
    window.addEventListener('scroll', stickyContentHandle);

    if (filter.manufacturer.length > 0 || filter.delivery) {
      setShowClean(true);
    } else {
      setShowClean(false);
    }

    return () => {
      window.removeEventListener('scroll', stickyContentHandle);
    }
  })

  const getCountManufacturer = (item) => {
    return productsCatalog.filter(product => product.manufacturer.name.indexOf(item) >= 0).length;
  }

  const getCountCategories = (item) => {
    const cat1 = [item && item.category_id];
    const cat2 = item && item.all_children ? item.all_children.map((child) => child.category_id) : [];
    const con = cat1.concat(cat2);

    let test = [];
    if (item && item.all_children) {
      item.all_children.forEach((child) => child.all_children.forEach((grand) => {test.push(grand.category_id)}))
    }
    const id = con.concat(test);

    return productsCatalog.filter((product) => id.includes(product.category_id)).length;
  }

  const getCountDelivery = (item) => {
    if (item === "locally") {
      if (filter.category || filter.manufacturer) {
        return productsCatalog.length
      } else {
        return products.length;
      }
    } else if (item === "allCountry") {
      if (filter.category || filter.manufacturer) {
        return productsCatalog.filter(p => p.product_id === 925 || p.product_id === 1133 || p.product_id === 1134).length;
      } else {
        return products.length;
      }
    }
  }

  const getManufacturer = (e, item) => {
    e.preventDefault();
    setTimeout(() => {
      toTop();
    }, 100);
    filterManufacturer(item);
  }

  const getCategory = (e, item) => {
    e.preventDefault();
    setTimeout(() => {
      toTop();
    }, 100);
    filterCategories(item);
  }

  const getDelivery = (e, item) => {
    e.preventDefault();
    if (getCountDelivery(item) > 0) {
      setTimeout(() => {
        toTop();
      }, 100);
      filterDelivery(item);
    }
  }

  const cleanFilters = (e) => {
    e.preventDefault();
    cleanFilter();
  }

  const cleanCategories = (e) => {
    e.preventDefault();
    cleanCategory();
  }

  const top = () => {
    if (document.querySelector('.sticky-sidebar')) {
      document.querySelector('.sticky-sidebar').style.top = 300 + 'px';
      document.querySelector(".sticky-sidebar").style.opacity = 0;
    }
  }
  
  const mFilter = manufacturers.sort((a, b) => a.name > b.name).filter(m => getCountManufacturer(m.name) >= 1 ? m : null);

  const p1 = categories.find(a => a.all_children.find(b => b.category_id === filter.category.category_id));
  const p2 = categories.find(a => a.all_children.find(b => b.all_children.find(c => c.category_id === filter.category.category_id)));

  const ch = p2 ? p2.all_children.find(a => a.category_id === filter.category.category_parent_id) : null;

  return (
    <StickyBox className="sidebar-wrapper sticky-sidebar" offsetTop={70}>
      {
        link !== "filterTwo" ?
          <>
            <h2 style={{fontSize: "2rem"}}>Kategorie</h2>
            <Categories>
              {
                !filter.category ? (
                  categories.map((obj) => (
                    obj.category_active && getCountCategories(obj) > 0 ? (
                        <li key={obj.category_id}>
                          <Link to="#" onClick={(e) => getCategory(e, obj)}>{obj.category_name}&nbsp;</Link>
                          <span>({getCountCategories(obj)})</span>
                        </li>
                      )
                    : ""
                  )))
                : (
                  <>
                    <span>cofnij do: <Link to="#" onClick={(e) => cleanCategories(e)} className="undo">wszystkie</Link></span>
                    <li className="parent">
                      <Link to="#" onClick={(e) => getCategory(e, ch ? ch : p1 ? p1 : "")}>{filter.category.category_name}&nbsp;</Link>
                      <span>({getCountCategories(filter.category)})</span>
                    </li>
                    {filter.category.all_children.map((obj) => (
                      obj.category_active && getCountCategories(obj) > 0 ? (
                          <ul key={obj.category_id}>
                            <li>
                              <Link to="#" onClick={(e) => getCategory(e, obj)}>{obj.category_name}&nbsp;</Link>
                              <span>({getCountCategories(obj)})</span>
                            </li>
                          </ul>
                        )
                      : ""
                    ))}
                  </>
                )
              }
            </Categories>
          </>
        : null
      }
      <Filters className="d-flex">
        <h2 style={{fontSize: "2rem"}}>Filtry</h2>
        {
          showClean && (
            <div className="clean-filter">
              <button onClick={cleanFilters}>Wyczyść</button>
            </div>
          )
        }
      </Filters>
      {
        link !== "filterTwo" ? 
          <>
            <Widget>
              <h3 className="widget-title">
                <a href="#widget-body-2" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="widget-body-2" onClick={(e) => top}>Producenci</a>
              </h3>
              <div className="collapse show" id="widget-body-2">
                <div className="widget-body">
                  <ul>
                    {
                      mFilter.map(m => (
                        m.active ? (
                          <li key={m.id}>
                            <input type="checkbox" id={m.id} checked={filter.manufacturer.includes(m.name) ? "checked" : ""} />
                            <label htmlFor={m.id} onClick={(e) => getManufacturer(e, m.name)}>
                              {m.name}&nbsp;
                              <span>({getCountManufacturer(m.name)})</span>
                            </label>
                          </li>
                          )
                        : ""
                      ))
                    }
                  </ul>
                </div>
              </div>
            </Widget>
            <Widget>
              <h3 className="widget-title">
                <a href="#widget-body-3" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="widget-body-2" onClick={(e) => top}>Dostawa</a>
              </h3>
              <div className="collapse show" id="widget-body-3">
                <div className="widget-body">
                  <ul>
                    <li>
                      <input type="checkbox" id="locally" checked={filter.delivery === "locally" ? "checked" : ""} />
                      <label htmlFor="locally" onClick={(e) => getDelivery(e, "locally")}>
                        Lokalnie&nbsp;
                        <span>({getCountDelivery("locally")})&nbsp;&nbsp;</span>
                      </label>
                      <Link to="/info/mapa-zasiegu" target="_blank" className="delivery-maps">mapa dostaw</Link>
                    </li>
                    <li>
                      <input type="checkbox" id="allCountry" checked={filter.delivery === "allCountry" ? "checked" : ""} />
                      <label htmlFor="allCountry" onClick={(e) => getDelivery(e, "allCountry")} style={{color: getCountDelivery("allCountry") === 0 ? "#899296" : "", cursor: getCountDelivery("allCountry") === 0 ? "default" : "pointer"}}>
                        Cała Polska&nbsp;
                        <span>({getCountDelivery("allCountry")})</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </Widget>
          </>
        : null
      }
    </StickyBox>
  )
}

const Categories = styled.ul`
  list-style: none;
  line-height: 2;

  span {
    a {
      color: #ff6a00;

      &:hover {
        color: #002b4f;
      }
    }
  }

  li {
    list-style: none;

    &.parent {
      font-weight: 700;
      color: #ff6a00;
    }

    span {
      color: #899296;
      font-weight: normal;
    }
  }

  ul {
    padding-left: 2.5rem;
  }
`;

const Filters = styled.div`
  align-items: end;
  justify-content: space-between;

  .clean-filter {
    margin-bottom: 1.8rem;

    button {
      background-color: transparent;
      border: 0;
      text-transform: uppercase;
      padding: 0;
      color: #ff6a00;
      align-self: end;
      transition: all .3s;

      &:hover {
        color: #002b4f;
      }
    }
  }
`;

const Widget = styled.div`
  ul {
    list-style: none;
    line-height: 2;

    label {
      transition: all .3s;
      cursor: pointer;
      
      &:hover {
        color: #ff6a00;
      }
    }

    span {
      color: #899296;
    }

    input[type=checkbox] {
      display: none;
    }

    input[type=checkbox] + label {
      display: inline;
      background: url("https://buduj.pl/assets/images/checkbox.webp") no-repeat;
      padding: 0 0 0 30px;
    }

    input[type=checkbox]:checked + label {
      display: inline;
      background: url("https://buduj.pl/assets/images/checkbox_checked.webp") no-repeat;
    }
  }

  .delivery-maps {
    color: #ff6a00;
    font-size: 12px;

    &:hover {
      color: #002b4f;
    }
  }
`

const mapStateToProps = (state) => {
  return {
    filter: state.filter ? state.filter : [],
    categories: state.categories.categories ? state.categories.categories : [],
    manufacturers: state.manufacturers.manufacturers ? state.manufacturers.manufacturers : []
  }
}

export default connect(mapStateToProps, { filterCategories, filterManufacturer, filterDelivery, cleanFilter, cleanCategory })(ShopSidebar);
